import React from 'react';

import OverviewBatteryFeatures from './OverviewBatteryFeature';
import Searches from './Search';
import ClientBatteriesCode from './ClientBatteriesCode'
function ClientBatteries(){

    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Battery</p>

           <Searches />
           <ClientBatteriesCode />
          
          </div>
        </>
    )
}

export default ClientBatteries;